import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedBlurb } from '../PdpSharedBlurbs/PdpSharedBlurb/PdpSharedBlurb.tsx';
import { type PdpRespSidebarBlurbReturnPolicy_item$key } from './__generated__/PdpRespSidebarBlurbReturnPolicy_item.graphql.ts';

const itemFragment = graphql`
    fragment PdpRespSidebarBlurbReturnPolicy_item on Item {
        returnPolicy(userId: $userId) {
            buyerCopy {
                returnPolicySectionHeader {
                    htmlCopy
                }
                returnPolicySection(userCountryCode: $userCountryCode) @include(if: $afterDisplay) {
                    htmlCopy
                }
                customizableDetailReturnCopy {
                    htmlCopy
                }
            }
        }
    }
`;

export const PdpRespSidebarBlurbReturnPolicy: FC<{
    item: PdpRespSidebarBlurbReturnPolicy_item$key;
}> = ({ item: itemRef }) => {
    const item = useFragment(itemFragment, itemRef);

    const buyerCopy = item?.returnPolicy?.buyerCopy;
    const returnPolicySectionHeader = buyerCopy?.returnPolicySectionHeader?.htmlCopy || '';
    const returnPolicySection = buyerCopy?.returnPolicySection?.htmlCopy || '';
    const customizableCopy = buyerCopy?.customizableDetailReturnCopy?.htmlCopy;

    const blurbCopy = customizableCopy
        ? `${returnPolicySection} ${customizableCopy}`
        : returnPolicySection;

    return (
        <PdpSharedBlurb
            IconComponent={null}
            zeroPadding
            title={returnPolicySectionHeader}
            detail={blurbCopy}
        />
    );
};
